// DS: C85A, C85A_M
import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-shared-react/pkg/Context';
import { BiDataHook } from '@wix/da-shared-react/pkg/biLogger/constants';
import { TabBarProps } from './types';
import SearchBar from './_partials/SearchBar';
import MenuItem from './_partials/MenuItem';
import { useScrollToActiveItem } from './hooks/useScrollToActiveItem';

import s from './Header.scss';

const Header: React.FC<TabBarProps> = ({
  isSearchPage,
  pageType,
  items = [],
  title,
  tagline,
  rightSideContent,
  activeMenuItem,
  children,
  className,
  withNavigation = true,
}) => {
  const isMobile = useContext(MobileContext);
  const { navListRef, activeItemRef } = useScrollToActiveItem(isMobile, 0);

  const setActiveItemRef = (page?: string) =>
    page === activeMenuItem
      ? (node: HTMLElement) => {
          activeItemRef.current = node;
        }
      : undefined;

  const titleBlock = title && (
    <div
      className={classnames(s['title'], !withNavigation && s['no-background'])}
    >
      <div className={s['headline']}>{title}</div>
      {tagline && <div className={s['tagline']}>{tagline}</div>}
    </div>
  );

  return (
    <>
      {isSearchPage && (
        <SearchBar isMobile={isMobile} pageType={pageType as any} />
      )}
      {isMobile && titleBlock}
      <div
        className={classnames(
          s['header-container'],
          (!isMobile || withNavigation) && s['sticky'],
          className
        )}
      >
        <header className={s['header']} data-hook={BiDataHook.DEVIATION_NAV}>
          {!isMobile && titleBlock}
          {withNavigation && (
            <div className={s['navigation']}>
              {children}
              {!children && items.length > 0 && (
                <ul className={s['nav-list']} ref={navListRef}>
                  {items.map(menuItem => (
                    <li
                      key={menuItem.subnav}
                      className={classnames(
                        s['nav-list__item'],
                        activeMenuItem === menuItem.subnav && s['active']
                      )}
                    >
                      <MenuItem
                        menuItem={menuItem}
                        isActive={activeMenuItem === menuItem.subnav}
                        className={s['nav-list__item__link']}
                        innerRef={setActiveItemRef(menuItem.subnav)}
                      />
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
          <div className={s['right-side']}>{rightSideContent}</div>
        </header>
      </div>
    </>
  );
};
Header.displayName = 'Header';

export default Header;
